import { ContractList } from "Components/ContractList";

const ContractPage = () => <ContractList />;

export default ContractPage;
